import { basicEnum } from "./base";

export const SurveyStepStatusEnum = basicEnum([
    {
        label: "EMPTY",
        value: "E",
    },
    {
        label: "INITIALIZED",
        value: "I",
    },
    {
        label: "PROGRESSING",
        value: "P",
    },
    {
        label: "DONE",
        value: "D",
    },
    {
        label: "SKIPPED",
        value: "X",
    },
]);

export namespace SurveyStepStatusEnum {
    export type Labels = (typeof SurveyStepStatusEnum)["labels"][number];
    export type Values = (typeof SurveyStepStatusEnum)["values"][number];
}
